import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { getUser, clearSession } from '../services/auth';

class LayoutInner extends React.Component {
  state = { mobileNavOpen: false };

  componentDidUpdate(prevProps) {
    if (prevProps.pathname !== this.props.pathname && this.state.mobileNavOpen) {
      this.setState({ mobileNavOpen: false });
    }
  }

  handleLogout = () => {
    clearSession();
    this.props.navigate('/login');
  };

  toggleMobileNav = () => {
    this.setState({ mobileNavOpen: !this.state.mobileNavOpen });
  };

  closeMobileNav = () => {
    this.setState({ mobileNavOpen: false });
  };

  render() {
    const user = getUser();
    const { mobileNavOpen } = this.state;

    return (
      <div className="shell">
        <button
          className="mobile-nav-toggle"
          onClick={this.toggleMobileNav}
          aria-label="Toggle navigation menu"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        {mobileNavOpen && <div className="sidebar-backdrop" onClick={this.closeMobileNav} />}

        <aside className={`sidebar ${mobileNavOpen ? 'open' : ''}`}>
          <div className="sidebar-brand">
            KTS Invoice
            <span className="stub">Kabra Travel Services</span>
          </div>

          <NavLink to="/invoices" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Generate Invoice
          </NavLink>
          <NavLink to="/hotels" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Hotels
          </NavLink>
          <NavLink to="/companies" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Companies
          </NavLink>
          <NavLink to="/states" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            State of Company
          </NavLink>
          <NavLink to="/reports" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Reports
          </NavLink>

          <div className="sidebar-footer">
            {user && (
              <div className="user-chip">
                {user.name}
                <span className="role">{user.role}</span>
              </div>
            )}
            <button className="logout-link" onClick={this.handleLogout}>Sign out</button>
          </div>
        </aside>

        <main className="main">{this.props.children}</main>
      </div>
    );
  }
}

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  return <LayoutInner navigate={navigate} pathname={location.pathname}>{children}</LayoutInner>;
}